import {Fragment, useEffect, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, CenteredModal, Table, SkeletonTableLoading, FormInput, DropzoneFile} from "~/components";
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import OurServiceAPI from "~/api/ourServiceApi";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";

const breadCrumbItem = [
    { text: "Landing Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Our Service", to: "", isActive: true },
]
function AdminOurService(){
    const [reloadTable, setReloadTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [ourService, setOurService] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const tableConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'OurServiceId'
            },
            {
                name: 'TITLE',
                width: '200px',
                key: 'Title'
            },
            {
                name: 'DESCRIPTION',
                width: '300px',
                key: 'Description'
            },
            {
                name: 'ICON',
                width: '130px',
                key: 'Icon',
                headerClassName: 'text-center',
                className: 'text-center',
                template: (row) => {
                    return (
                        <div dangerouslySetInnerHTML={{ __html: row.Icon }} />
                    )
                }
            },
            {
                name: 'MODIFIED BY',
                width: '150px',
                key: 'ModifiedBy'
            },
            {
                name: 'MODIFIED DATE',
                width: '150px',
                key: 'ModifiedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.ModifiedDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                headerClassName: 'text-center',
                className: 'text-center',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleShowActionModal(row.OurServiceId)} icon={faEdit} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        tableKey: "TableOurService",
        hasShowHideColumn: false
    }

    useEffect(() => {
        setLoading(true)
        OurServiceAPI.getAll()
            .then((res) => {
                setOurService(res.data);
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                setLoading(false);
            })
    }, [reloadTable]);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const handleShowActionModal = (ourServiceId) => {
        OurServiceAPI.getById(ourServiceId)
            .then((res) => {
                if (res.data) {
                    fetch(res.data.ThumbnailUrl)
                        .then((response) => response.blob())
                        .then((blob) => {
                            const file = new File([blob], res.data.ThumbnailFileName, { type: blob.type });
                            const preview = URL.createObjectURL(file);
                            const newFile = {
                                name: file.name,
                                size: (file.size / 1024).toFixed(2) + " KB",
                                preview,
                                file,
                            };
                            setSelectedFile(newFile);
                        })
                        .catch((err) => {
                            ;
                        });
                }
                reset(res.data);
                setShowModal(true);
            })
            .catch((err) => {
                ;
            })
    }

    const onSubmitFrom = (data) => {
        const { file, ...restData } = data;
        const formData = new FormData();
        Object.entries(restData).forEach(([key, value]) => {
            formData.append(key, value);
        });
        if (file?.[0]) {
            formData.append("file", file[0]);
        }
        OurServiceAPI.update(formData)
            .then((res) => {
                res.data?.Success ?
                    toast.success(<span className="fs-9 fw-bold">Your our service has been updated.</span>)
                    : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your our service.</span>)
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your our service.</span>)
            })
            .finally(() => {
                handleCloseModal();
                setReloadTable(prev => !prev);
            })
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedFile(null);
    }

    return(
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-5">Our Service</h2>
            {loading ? (
                <SkeletonTableLoading columns={tableConfig.columns} rows={10} />
            ) : (
                <Table tableConfig={{...tableConfig, data : ourService}}/>
            )}
            <CenteredModal
                show={showModal}
                onClose={() => setShowModal(false)}
                title="Edit Our Service"
                formId="formActionOurService"
            >
                <form onSubmit={handleSubmit(onSubmitFrom)} id="formActionOurService">
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name="Title"
                                   errors={errors}
                                   label={`Assign Title`}
                                   maxLengthText="max length 255 character"
                                   validation={{...register("Title", {
                                           required: "Title is required."
                                       })}}
                        />
                    </div>
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name="Description"
                                   errors={errors}
                                   label={`Assign Description`}
                                   textarea={true}
                                   validation={{...register("Description", {
                                           required: "Description is required."
                                       })}}
                        />
                    </div>
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name="Icon"
                                   errors={errors}
                                   label={`Assign Icon`}
                                   maxLengthText="max length 100 character"
                                   validation={{...register("Icon", {
                                           required: "Icon is required."
                                       })}}
                        />
                    </div>
                    <div className="mb-3">
                        <DropzoneFile
                            label="Assign Thumbnail(*)"
                            register={register}
                            name="file"
                            errors={errors}
                            selectedFile={selectedFile}
                            setSelectedFile={setSelectedFile}
                        />
                    </div>
                </form>
            </CenteredModal>
        </Fragment>
    )
}
export default AdminOurService;